import { Helmet } from 'react-helmet';
import _capitalize from 'lodash/capitalize';

import config from ':cloud/config';

function envAppTitle(env: string): string {
  return env === 'production' ? 'Quest' : `${_capitalize(env)} - Quest`;
}

export function BuildQuestHelmet() {
  return (
    <Helmet>
      <meta charSet="utf-8" />
      <meta
        name="viewport"
        content="width=device-width, initial-scale=0.8, maximum-scale=1.0, user-scalable=no"
      />

      {/* manifest.json provides metadata used when your web app is added to the
      homescreen on Android. See https://developers.google.com/web/fundamentals/web-app-manifest/ */}
      <link rel="manifest" href="/static/manifest.json" />
      <link rel="icon" type="image/png" href="/static/favicon.ico" />

      <title>CDP Quest</title>
      <title>{envAppTitle(config.environmentName)}</title>
      <meta
        name="description"
        content="An online interactive onchain building adventure where builders complete challenges on Base & the Coinbase Developer Platform to earn points & unlock cool swag."
      />
    </Helmet>
  );
}
